import React from "react";
import * as api from "./api";
import * as Storage from "./Storage";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_CANDIDAT = "ROLE_CANDIDAT";
export const ROLE_REUNION_ENFANT = "ROLE_REUNION_ENFANT";

///////////////////////////////////////////////////////////////////////////////////////////////
export const timediaUrl = api.timediaUrl;
export const urlTimediaSearch = timediaUrl + "/public/medias";

const auth = {
  inscriptionUser(self, callback) {
    fetch(`${timediaUrl}/public/inscriptionUser`, {
      ...api.defaultParams,
      method: "POST",
      body: JSON.stringify({
        email: self.state.email.value,
        prenom: self.state.prenom.value,
        nom: self.state.nom.value,
        password: self.state.password.value,
        lieuNaissance: self.state.lieuNaissance.value,
        dateNaissance: self.state.dateNaissance.value,
        telMobile: self.state.telMobile.value
      })
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("Error: " + response.status);
          return;
        }
        response.json().then(data => {
          callback(data);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  authenticate(email, password, callback) {
    fetch(`${timediaUrl}/users/auth`, {
      method: "POST",
      body: JSON.stringify({
        login: email.value,
        pass: password.value
      }),
      headers: {
        Authorization:
          "Basic QVVUSEVOVElDQVRJT046OThHMDhHVVlHODdHOThVR0lPVVlHODk3",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("Error: " + response.status);
          return;
        }
        response.json().then(data => {
          const values = JSON.stringify(data.data);
          callback(values, data);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  authenticateByToken(token, callback) {
    fetch(`${timediaUrl}/public/authByToken/${token}`, {
      ...api.defaultParams,
      method: "GET"
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("Error: " + response.status);
          return;
        }
        response.json().then(data => {
          callback(data);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  changePassword(token, password, callback) {
    fetch(`${timediaUrl}/public/userPasswordChange/${token}`, {
      ...api.defaultParams,
      method: "PUT",
      body: JSON.stringify({
        newPassword: password
      })
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("Error: " + response.status);
          return;
        }
        response.json().then(data => {
          callback(data);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  sendAuthLinkByMail(email, callback) {
    fetch(`${timediaUrl}/public/sendLinkUserPasswordForgot`, {
      ...api.defaultParams,
      method: "PUT",
      body: JSON.stringify({
        email: email
      })
    })
      .then(response => {
        if (response.status !== 200) {
          console.log("Error: " + response.status);
          return;
        }
        response.json().then(data => {
          callback(data);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  signout(callback) {
	// localStorage.removeItem("user");
    Storage.removeUser();
    // localStorage.removeItem("authorities");
    Storage.removeAuthorities();

    // localStorage.setItem("authorities", JSON.stringify(["ROLE_PUBLIC"]));
    Storage.setAuthoritiesJson(JSON.stringify(["ROLE_PUBLIC"]));
    if (callback && typeof callback === "function") {
      callback();
    }
  },

  getUser() {
    var user = Storage.getUserParsed();
    // var user = localStorage.getItem("user");
    // user = JSON.parse(user);
    return user;
  },

  isAuthenticated() {

    console.log(Storage.getAuthoritiesJson());
    console.log(Storage.getUserParsed());

    // if (localStorage.getItem("authorities") === null) {
    if (Storage.getAuthoritiesJson() === null) {
      // localStorage.setItem("authorities", JSON.stringify(["ROLE_PUBLIC"]));
      Storage.setAuthoritiesJson(JSON.stringify(["ROLE_PUBLIC"]));
      window.location.reload();
    }
    // if (localStorage.getItem("user") === null) {
    if (JSON.stringify(Storage.getUserParsed()) === JSON.stringify({})) {
      console.log("oui")
      return false;
    } else {
      return true;
    }
  },

  userHaveAuthorities(authorities) {
    return (
      (this.isAuthenticated() && this.hasRoles(authorities)) ||
      this.hasRoles(["ROLE_ADMIN"])
    );
  },

  hasRoles(values) {
    var retour = false;
    // console.log(values);
    // var authorities = JSON.parse(localStorage.getItem("authorities"));
    var authorities = Storage.getAuthoritiesJson();
    if (authorities !== null) {
      values.forEach(function(value) {
        if (authorities.includes(value) || authorities.includes("ROLE_ADMIN")) {
          retour = true;
        }
      });
    }
    return retour;
  },

  updateAuthorities() {
    // const user = JSON.parse(localStorage.getItem("user"));
    const user = Storage.getUserParsed();
    if (user !== null) {
      fetch(`${timediaUrl}/public/getAuthorities`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Basic " + user.token
        },
        method: "PUT",
        body: window.location.href
      })
        .then(response => {
          if (response.status !== 200) {
            console.error("Error: " + response.status);
            return;
          }
          response.json().then(json => {
            var data = JSON.stringify(json);
            var authorities = new Array();
            json.data.forEach(function(authority) {
              authorities.push(authority.name);
            });
            // localStorage.setItem("authorities", JSON.stringify(authorities));
            Storage.setAuthoritiesJson(JSON.stringify(authorities));
          });
        })
        .catch(function(error) {
          // auth.signout();
        });
    }
  }
};
export default auth;
